// @ts-nocheck
import React from "react";
import cn from "classnames";
import PropTypes from "prop-types";
import Helmet from "react-helmet";
import { CookieBanner, Container } from "react-components";

import ProductHunt from "../productHunt";
import "react-components/src/_styles/index.css";
import useIsSsr from "../../hooks/useIsSsr";

import { CookieConsentsContext } from "../../context/cookieConsents";
import { getTagManager } from "../../helpers/scripts/tagManager";
import { getFullStory } from "../../helpers/scripts/fullstory";
import { getPosthog } from "../../helpers/scripts/posthog";

import Footer from "../footer";
import PageNav from "../pageNav";

import styles from "./styles.css";

import headerItems from "./headerItems.json"
import footerItems from "./footerItems.json"

const isDev = process.env.NODE_ENV === "development";

const Scripts = ({ cookieConsents }) => {
    const scripts = [
        ...(cookieConsents?.preferences && cookieConsents?.statistics
            ? getTagManager({ id: "GTM-5JRBS2N", optimizeId: "OPT-MXG3TDC" })
            : []),
        ...getFullStory({ fsOrg: "16WG6R" }),
        ...getPosthog({
            posthogApiKey: isDev
                ? "phc_mU2rlaws8Jnxe4MkXTrwGpek3vyltRdTH6gCT7swpww"
                : "phc_BNW0TpUsgbrLmL3tl9AGtbU6TGd0BVexwaGwLS6nrW3",
        }),
    ];

    return <Helmet>{cookieConsents?.marketing ? scripts : []}</Helmet>;
};

const Layout = ({
    children,
    className,
    background = "pink",
    footerBackground = "pink",
    navigation = "default",
    navigationAppearance,
    pageNavContainerBg,
}) => {
    const { cookieConsents, acceptAllCookieConsents, rejectAllCookieConsents } =
        React.useContext(CookieConsentsContext);

    const base = __PATH_PREFIX__;
    const font = `${base}/assets/fonts`;
    const preload = { rel: "preload", as: "font", type: "font/woff2", crossOrigin: "anonymous" };
    const headers = (
        <Helmet>
            <link href={`${font}/inter/Inter-roman.var.woff2`} {...preload} />
            <link href={`${font}/whereby-roslindale/WherebyRoslindaleDisplayCondensed-Regular.woff2`} {...preload} />
            <link href={`${font}/whereby-roslindale/WherebyRoslindaleText-Regular.woff2`} {...preload} />
            <link href={`${font}/whereby-fonts.css`} rel={"stylesheet"} type={"text/css"} />
        </Helmet>
    );

    const isSsr = useIsSsr();

    return (
        <>
            <div id={"app"}>
                <Scripts cookieConsents={cookieConsents} />
                {headers}
                <div className={cn(styles.layout, styles[`layout--${background}`], className)}>
                    {navigation !== "no-nav" && (
                        <PageNav
                            variant={navigation}
                            appearance={navigationAppearance}
                            className={cn(styles.pageNav, styles[`pageNav--${background}`])}
                            pageNavContainerBg={pageNavContainerBg}
                            items={headerItems}
                        />
                    )}
                    <main className={styles.mainContent}>{children}</main>
                    <div className={cn(styles.footer, styles[`footer--${footerBackground}`])}>
                        <Container size={"page"}>
                            <Footer items={footerItems} />
                        </Container>
                    </div>
                </div>
                {cookieConsents === null ? (
                    <div className={styles.cookieBannerWrapper}>
                        <CookieBanner
                            onAccept={acceptAllCookieConsents}
                            onReject={rejectAllCookieConsents}
                            cookieSettingsContinue={isSsr ? undefined : window.location.href}
                        />
                    </div>
                ) : null}
                <ProductHunt />
            </div>
        </>
    );
};

Layout.propTypes = {
    background: PropTypes.oneOf(["pink", "yellow", "grey", "white"]),
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    footerBackground: PropTypes.oneOf(["pink", "yellow", "grey", "white"]),
    navigation: PropTypes.string,
    navigationAppearance: PropTypes.string,
    pageNavContainerBg: PropTypes.string,
};

export default Layout;
